import IconAvatar from "common/components/IconAvatar";
import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import { LEAD_LIST_SOURCE_TYPES } from "../../constants";

import type { LeadListSourceType } from "../../types";

interface LeadListSourceTypeTagProps {
  type: LeadListSourceType;
  isCompact?: boolean;
}

export default function LeadListSourceTypeTag({
  type,
  isCompact = false,
}: LeadListSourceTypeTagProps) {
  const {
    icon: Icon,
    label,
    tagVariant,
    iconContainerClassName,
  } = LEAD_LIST_SOURCE_TYPES[type];

  if (isCompact) {
    return (
      <Tooltip>
        <TooltipTrigger>
          <IconAvatar size="xs" className={iconContainerClassName}>
            <Icon />
          </IconAvatar>
        </TooltipTrigger>

        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tag variant={tagVariant} size="sm" className="w-fit" leftIcon={<Icon />}>
      {label}
    </Tag>
  );
}
